import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	max-width: 1280px;
	margin: 0 auto;

	padding: 50px 20px;

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		padding: 100px 40px;
	}

	.platforms-container {
		margin-top: 50px;
		display: grid;

		grid-gap: 50px;
		grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
		grid-auto-rows: minmax(auto, 150px);

		.platform-card {
			background-color: ${CSSVars.white};
			display: flex;
			justify-content: center;
			padding: 50px;
			border-radius: 10px;
			transition: 0.2s;
			border: 1px solid ${CSSVars.gray50};

			&:hover {
				border: 1px solid ${CSSVars.gray100};
			}

			.img-wrapper {
				img {
					max-width: 100%;
					height: 100%;
					object-fit: contain;
					position: relative !important;
				}
			}
		}
	}
`;
